<template>
  <div class="flex flex-col space-y-5">
    <div class="text-center">
      Masonry Cladding Type
    </div>
    <div class="">
      <div class="flex flex-wrap -mx-2">
        <IconButton :on-click="() => $emit('update:modelValue', 'brick')" :is-active="modelValue === 'brick'">
          BRICK
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/07-brick.png" class="-mb-[25px]" />
          </template>
        </IconButton>
        <IconButton :on-click="() => $emit('update:modelValue', 'stone')" :is-active="modelValue === 'stone'">
          STONE
          <template v-slot:icon>

            <img src="../../../img/wall-builder/layers/07-stone.png" class="-mb-[25px]" />
          </template>
        </IconButton>
        <IconButton v-show="nfpa" :on-click="() => $emit('update:modelValue', 'terracota')" :is-active="modelValue === 'terracota'">
          TERRACOTA
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/07-terracota.png" class="-mb-[25px]" />
          </template>
        </IconButton>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "../components/IconButton.vue";
export default {
  data() {
    return {

    }
  },
  emits: ['update:modelValue'],
  props: {
      nfpa: Boolean,
    modelValue: {
      type: String,
      default: null
    }
  },
  components: {
    IconButton
  }
}
</script>
